import {
  everyUser,
  categoryIcon,
  quantri,
  popupIcon,
  setting
} from "@assets/icons";

export const menuNavigation = [
  {
    category: "admin",
    children: [
      {
        navItemName: "Quản lý Popup",
        path: "/admin/popup-management",
        click: true,
        reg: /(\/admin\/popup-management).{0,}/g,
        icon: popupIcon
      },
      {
        navItemName: "Quản lý thành viên",
        click: true,
        path: "/admin/user-management",
        reg: /(\/admin\/user-management).{0,}/g,
        icon: everyUser
      },
      {
        navItemName: "Quản lý admin",
        click: true,
        path: "/admin/admin-account-management",
        reg: /(\/admin\/admin-account-management).{0,}/g,
        icon: quantri
      },
      {
        navItemName: "Quản lý đơn hàng",
        click: true,
        path: "/admin/order-management",
        reg: /(\/admin\/order-management).{0,}/g,
        icon: categoryIcon
      },
      {
        navItemName: "Quản lý gói dịch vụ",
        click: true,
        path: "/admin/service-package-management",
        reg: /(\/admin\/service-package-management).{0,}/g,
        icon: setting
      },
      {
        navItemName: "Giám sát QR Scan",
        click: true,
        path: "/admin/qr-scan-monitor",
        reg: /(\/admin\/qr-scan-monitor).{0,}/g,
        icon: categoryIcon
      },
      {
        navItemName: "QR nghi ngờ",
        click: true,
        path: "/admin/url-scan-review",
        reg: /(\/admin\/url-scan-review).{0,}/g,
        icon: setting
      }
    ],
  },
];
